import React from 'react';
import SweetAlert from 'sweetalert-react';
import $ from 'jquery';
import * as requestLib from '../../lib/requestLib';

class AddGroupView extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			groupName: '',
			groupSentence: '',
			groupNameValidation: false,
			groupSentenceValidation: false,
		};

		this.baseUrl = requestLib.getUrl();
	}

	addGroup() {
		if (this.state.groupName === '') {
			this.setState({ groupNameValidation: true });
		} else if (this.state.groupSentence === '') {
			this.setState({ groupSentenceValidation: true });
		} else {
			let accessToken = this.props.getCookie('accessToken');

			let data = {
				userToken: accessToken,
				title: this.state.groupName,
				content: this.state.groupSentence,
			};

			$.ajax({
				url: this.baseUrl + 'api/Group/createGroup',
				data,
				method: 'post',
				dataType: 'json',
				success: function (response) {

					this.props.setAddGroupView();
				}.bind(this),
				error: function (e) { }.bind(this),
			});
		}
	}

	render() {
		return (
			<div className="overlay">
				<div className="addGroupForm">
					<span onClick={() => this.props.setAddGroup()}>&times;</span>
					{/*<i className="fas fa-times" onClick={ () => this.setState({addGroupView:false})}></i>*/}
					<h1>Create a New Group</h1>
					<input
						type="text"
						placeholder="Group Name"
						value={this.state.groupName}
						onChange={(e) => this.setState({ groupName: e.target.value })}
					/>
					<input
						type="text"
						placeholder="Please describe this group in a sentence."
						value={this.state.groupSentence}
						onChange={(e) => this.setState({ groupSentence: e.target.value })}
					/>
					<SweetAlert
						show={this.state.groupNameValidation}
						title="You must fill in both fields."
						text=""
						onConfirm={() => {
							this.setState({ groupNameValidation: false });
						}}
					/>
					<SweetAlert
						show={this.state.groupSentenceValidation}
						title="You must fill in both fields."
						text=""
						onConfirm={() => {
							this.setState({
								groupSentenceValidation: false,
							});
						}}
					/>
					<button onClick={() => this.addGroup()}>Create</button>
				</div>
			</div>
		);
	}
}

export default AddGroupView;



// WEBPACK FOOTER //
// ./src/components/Group/AddGroupView.jsx